<template>
    <div :data-component="$options.name">
        <cs-modal
            :visible="modalIsVisible"
            :headerText="'Merkliste'"
            @update:visible="onUpdateVisibility"
        >
            <div class="flex flex-col">
                <ms-headline
                    v-if="hasBookmarks"
                    type="h3"
                    class="mb-16"
                    :isSpan="true"
                    >Meine Merkliste ({{ getBookmarkLength() }}/20)</ms-headline
                >
                <cs-notification :notification-state="infoState">
                    <template #headline>Hinweis</template>
                    Deine Browsereinstellungen beeinflussen, wie lange deine Merkliste gespeichert wird. Beim
                    Safari-Browser kann es passieren, dass deine Merkliste nach sieben Tagen automatisch geleert wird.
                </cs-notification>
                <template v-if="bookmarks.own.length">
                    <ul class="flex flex-col mt-16 screen-m:mt-24 gap-16 screen-m:gap-24">
                        <ms-bookmark-item
                            v-for="(bookmark, index) in reverse(bookmarks.own)"
                            :key="bookmark.guid"
                            :bookmarkItem="bookmark"
                            :isOwnInventory="true"
                            :position="index + 1"
                            :componentId="componentId"
                            data-jest-own
                            @onBookmarkRemoved="showToast"
                        />
                    </ul>
                </template>
                <template v-if="bookmarks.immo.length">
                    <ul class="flex flex-col mt-16 screen-m:mt-24 gap-16 screen-m:gap-24">
                        <ms-bookmark-item
                            v-for="(bookmark, index) in reverse(bookmarks.immo)"
                            :key="bookmark.guid"
                            :bookmarkItem="bookmark"
                            :isOwnInventory="false"
                            :position="determinePosition(index + 1)"
                            :componentId="componentId"
                            data-jest-immo
                            @onBookmarkRemoved="showToast"
                        />
                    </ul>
                </template>
                <div
                    v-if="!hasBookmarks"
                    class="flex flex-col items-center mt-16"
                >
                    <MsEmptyResultListSvg class="mb-16" />
                    <ms-headline
                        type="h3"
                        class="mb-8"
                        :isSpan="true"
                        >Deine Merkliste ist leer</ms-headline
                    >
                    <p class="text-text-l text-center">
                        Aktuell hast du keine Angebote gespeichert. Schau dich gerne nach einer passenden Immobilie um.
                    </p>
                </div>
            </div>
            <ms-local-toast-manager
                class="absolute left-0 right-0 bottom-0 screen-m:mb-64"
                :modelValue="toasts"
                @update:modelValue="onUpdate"
            />
        </cs-modal>
    </div>
</template>
<script lang="ts" src="./MsBookmarkList.ts" />
